import React from "react"
import { Plus, CreditCard } from "lucide-react"
import type { ClientUnpaidOrdersResponse } from "../../types"

interface DashboardActionButtonsProps {
    isSessionClosed: boolean;
    showScheduledSkeleton: boolean;
    hasOrders: boolean;
    hasBalance: boolean;
    isTakeAway: boolean | null;
    orderTiming: string | null;
    unpaidOrders: ClientUnpaidOrdersResponse | null;
    onOrderClick: () => void;
    onPaymentClick: () => void;
}

export const DashboardActionButtons: React.FC<DashboardActionButtonsProps> = ({
    isSessionClosed,
    showScheduledSkeleton,
    hasOrders,
    hasBalance,
    isTakeAway,
    orderTiming,
    unpaidOrders,
    onOrderClick,
    onPaymentClick
}) => {
    if (isSessionClosed || showScheduledSkeleton) return null;

    return (
        <>
            {/* Botón Ordenar (cuando no hay órdenes ni balance) */}
            {!hasOrders && !hasBalance && (
                <div className="fixed bottom-20 left-1/2 -translate-x-1/2 w-full max-w-md px-4 z-40">
                    <div className="absolute inset-x-0 -bottom-2 h-8 bg-gradient-to-t from-white/95 to-transparent dark:from-gray-900/95 pointer-events-none"></div>
                    <div className="bg-white/90 dark:bg-gray-900/90 backdrop-blur-2xl rounded-3xl p-4 shadow-xl border border-gray-200/30 dark:border-gray-700/30 relative">
                        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-sky-300/50 to-transparent"></div>
                        <div className="flex gap-3">
                            <button
                                onClick={onOrderClick}
                                className="flex-1 bg-white/70 dark:bg-gray-800/70 backdrop-blur-sm hover:bg-white/90 dark:hover:bg-gray-700/90 border border-gray-200/40 dark:border-gray-600/40 hover:border-sky-300/60 dark:hover:border-sky-500/60 text-gray-900 dark:text-white py-4 rounded-2xl font-bold transition-all duration-300 flex items-center justify-center gap-3 shadow-md hover:shadow-lg hover:scale-[1.02]"
                            >
                                <Plus className="w-5 h-5" />
                                {orderTiming === 'week' ? 'Programar Orden' : 'Ordenar'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Botones Ordenar/Pagar (cuando hay órdenes o balance) */}
            {(hasOrders || hasBalance) && (
                <div className="fixed bottom-20 left-1/2 -translate-x-1/2 w-full max-w-md px-4 z-40">
                    <div className="absolute inset-x-0 -bottom-2 h-8 bg-gradient-to-t from-white/95 to-transparent dark:from-gray-900/95 pointer-events-none"></div>

                    <div className="bg-white/90 dark:bg-gray-900/90 backdrop-blur-2xl rounded-3xl p-4 shadow-xl border border-gray-200/30 dark:border-gray-700/30 relative">
                        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-sky-300/50 to-transparent"></div>

                        <div className="flex gap-3">
                            <button
                                onClick={onOrderClick}
                                className="flex-1 bg-white/70 dark:bg-gray-800/70 backdrop-blur-sm hover:bg-white/90 dark:hover:bg-gray-700/90 border border-gray-200/40 dark:border-gray-600/40 hover:border-sky-300/60 dark:hover:border-sky-500/60 text-gray-900 dark:text-white py-4 rounded-2xl font-bold transition-all duration-300 flex items-center justify-center gap-3 shadow-md hover:shadow-lg hover:scale-[1.02]"
                            >
                                <Plus className="w-5 h-5" />
                                {orderTiming === 'week' ? 'Programar Orden' : 'Ordenar'}
                            </button>

                            {hasBalance && unpaidOrders && (
                                <button
                                    onClick={onPaymentClick}
                                    className="flex-1 btn-primary py-4 rounded-2xl font-bold transition-all duration-300 flex items-center justify-center gap-3 shadow-md hover:shadow-lg hover:scale-[1.02]"
                                >
                                    <CreditCard className="w-5 h-5" />
                                    Pagar ${unpaidOrders.total_amount_owed.toFixed(2)}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
